import { useState } from "react";
import { Input } from "./Input";
import IconButton from "./IconButton";

// Password field with a trailing show/hide toggle. Owns the visibility state;
// every other prop (id, value, onChange, invalid, aria-*) goes to the input,
// so it drops into <Field> like any other control.
export default function PasswordInput({ className = "", ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="rl-input-wrap">
      <Input type={visible ? "text" : "password"} className={className} {...rest} />
      <span className="rl-input-wrap__trailing">
        <IconButton
          icon={visible ? "eye-off" : "eye"}
          label={visible ? "Hide password" : "Show password"}
          size="sm"
          onClick={() => setVisible((v) => !v)}
        />
      </span>
    </div>
  );
}
